import { intellisense, IntellisenseExpectedType } from './intellisense.js';
import { string } from './type-checkers.js';
const expression = intellisense(string, IntellisenseExpectedType.EXPRESSION)
    .group('expressions');
export { expression, };
//# sourceMappingURL=expression.js.map